module.exports = __webpack_public_path__ + "media/components/Sponsors/Scouts/Index/searchIcon-3f7d81a25f7b9d18619dd506bc03c75d.svg";